<template>
    <LayoutSub className="pb-0 kiosk">
        <SubpageTitleContainer
            title="EasyKIOSK"
            subText="업계 최초로 원천기술을 확보한 이지포스는 압도적인 기술력과 다양하고 풍부한 프로젝트 수행 노하우를 바탕으로 일반 가맹점부터 대형 프랜차이즈까지 안정적인 서비스를 제공하고 있습니다."
        >
        </SubpageTitleContainer>
        <SubSection class="pt-0">
            <RedTitleRow title="특징">
                <li>
                    <span class="list_num">01</span>
                    <p>KIOSK 인트로 화면 내 광고 동영상 삽입 가능 <strong>(매장 홍보 영상 및 이미지 등록 가능)</strong></p>
                </li>
                <li>
                    <span class="list_num">02</span>
                    <p>포장 및 매장 식사 버튼을 통해 주문서 구분 출력 가능</p>
                </li>
                <li>
                    <span class="list_num">03</span>
                    <p><strong>이지포스</strong>를 통해 <strong>키오스크 상품 품절/등록 처리</strong> 가능</p>
                </li>
                <li>
                    <span class="list_num">04</span>
                    <p><strong>이지포스</strong>에서 <strong>키오스크 매출 확인</strong> 가능</p>
                </li>
            </RedTitleRow>
        </SubSection>
        <SubSection type="wide">
            <SubTitle3 listStyle="dot">키오스크 종류</SubTitle3>
            <div class="inner_box">
                <div class="image_box">
                    <div class="imgs">
                        <img src="@/assets/pos_system_kiosk_image01.png" alt="" />
                    </div>
                    <div class="imgs">
                        <img src="@/assets/pos_system_kiosk_image02.png" alt="" />
                    </div>
                    <div class="imgs">
                        <img src="@/assets/pos_system_kiosk_image03.png" alt="" />
                    </div>
                </div>
            </div>
        </SubSection>
    </LayoutSub>
</template>

<script>
import LayoutSub from '@/layouts/LayoutSub.vue';
import SubSection from '@/components/SubSection.vue';
import RedTitleRow from '@/components/RedTitleRow.vue';
import SubpageTitleContainer from '@/components/SubpageTitleContainer.vue';
import SubTitle3 from '@/components/SubTitle3.vue';

export default {
    components: {
        LayoutSub,
        SubpageTitleContainer,
        RedTitleRow,
        SubSection,
        SubTitle3,
    },
};
</script>

<style lang="scss">
.inner_box {
  padding: 30px 0;
  background: #fff;
  .image_box {
      display: flex;
      overflow: auto;
      padding: 0 60px;
      gap: 30px;
  
      .imgs {
          flex: 1 0 320px;
      }
  }
}
</style>
